const initialState = {
    claimTypePermissions:{},
    claimTypeLists: [],
    claimTypeStatus: [],
    changedClaimTypeStatus : [],
    loadingClaimType: false,
    errorsClaimType: {}
}

const  claimTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_CLAIMTYPELIST_PENDING":
        case "ADD_CLAIMTYPE_PENDING":
        case "UPDATE_CLAIMTYPE_PENDING":
        case "UPDATE_CLAIMTYPE_STATUS_PENDING":
        case "DELETE_CLAIMTYPE_PENDING":
        case "GET_CLAIMTYPELISTBYID_PENDING":
            return { ...state, loadingClaimType: true };

        case "GET_CLAIMTYPELIST_FULFILLED":
            return {
                ...state,
                loadingClaimType: false,
                claimTypeLists: action.payload,
                claimTypeCount: action.claimTypeCount,
                claimTypePermissions:action.permissions,
            };

        case "ADD_CLAIMTYPE_FULFILLED":
            return {
                ...state,
                loadingClaimType: false,
                changedClaimTypeStatus: action.payload,
            };

        case "UPDATE_CLAIMTYPE_FULFILLED":
            return {
                ...state,
                loadingClaimType: false,
                changedClaimTypeStatus: action.payload,
            };

        case "UPDATE_CLAIMTYPE_STATUS_FULFILLED":
            return {
                ...state,
                loadingClaimType: false,
                changedClaimTypeStatus: action.payload,
            };

        case "GET_CLAIMTYPELISTBYID_FULFILLED":
            return {
                ...state,
                loadingClaimType: false,
                claimTypeLists: action.payload
            };

        case "DELETE_CLAIMTYPE_FULFILLED":
            return {
                ...state,
                loadingClaimType: false,
                changedClaimTypeStatus: action.payload
            };

        case "RESET_DELETE_CLAIMTYPE_STATUS":
            return {
                ...state,
                loadingClaimType: false,
                changedClaimTypeStatus: [],
                errorsClaimType:{}
            };

        case "GET_CLAIMTYPELIST_REJECTED":
        case "ADD_CLAIMTYPE_REJECTED":
        case "UPDATE_CLAIMTYPE_REJECTED":
        case "UPDATE_CLAIMTYPE_STATUS_REJECTED":
        case "DELETE_CLAIMTYPE_REJECTED":
        case "GET_CLAIMTYPELISTBYID_REJECTED":
            return {
                ...state,
                loadingClaimType: false,
                errorsClaimType: action.payload
            };

        default:
            return state;
    }
}

export default claimTypeReducer;